module.exports = __webpack_public_path__ + "h5/img/funv-navc1.25ee79b2.png";